import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { ColorStyle } from "src/utils/Colors";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { Route } from "src/config/routes";
import { useLocation } from "react-router-dom";
import "./CancelledInvoiceBanner.css";

import { INVOICE_STATE } from "src/stores/krediflow/InvoiceEnums";

const CancelledInvoiceBannerBase = () => {
    const { t } = useTranslation();
    const { invoiceStore } = useContext(RootStoreContext);
    const location = useLocation();

    return (
        <>
            {location.pathname.includes(Route.creditor) &&
            invoiceStore.currentInvoice?.state === INVOICE_STATE.CANCELLED ? (
                <div className="TicketArchivedModeBanner container-fluid">
                    <UI.Row>
                        <UI.Col xl={9} sm={9} className="d-flex align-items-center mb-4 mb-lg-0">
                            <UI.Icon
                                className="DemoModeInfoIcon"
                                icon={UI.SVGIcon.Information}
                                color={ColorStyle("white")}
                            />
                            <div className="DemoModeText">{t("screens.kredi_flow.cancelled_invoice_banner")}</div>
                        </UI.Col>
                    </UI.Row>
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export const CancelledInvoiceBanner = Sentry.withProfiler(observer(CancelledInvoiceBannerBase));
